var app = angular.module("leonardo");

var FeatureGateDialog = function($scope) {
  var parentScope = $scope.ngDialogData.parentScope;
  var featureType = $scope.ngDialogData.featureType || 'work_orders';
  
  // Set title based on feature type
  if (featureType === 'dynamic_forms') {
    $scope.title = "Learn more about Leo's Dynamic Form features";
  } else {
    $scope.title = "Learn more about Leo's Work Orders features";
  }
  
  $scope.goBack = function() {
    // Close this dialog first
    $scope.closeThisDialog();
    
    // Close the parent dialog
    if (parentScope && parentScope.closeThisDialog) {
      parentScope.closeThisDialog();
    }
  };
};

app.controller('FeatureGateDialog', ['$scope', FeatureGateDialog]);
